import Select from "react-select";
import chroma from "chroma-js";

const dot = (color = 'transparent') => ({
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,

    ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
        flexShrink: 0,
    },
});

const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(data.color);
        return {
            ...styles,

            ...dot(data.color),

            backgroundColor: isDisabled
                ? undefined
                : isSelected
                    ? 'rgba(84,133,228,.075)'
                    : isFocused
                        ? 'rgba(84,133,228,.075)'
                        : undefined,
            color: isDisabled
                ? '#ccc'
                : isSelected
                    ? '#3454d1'
                    : 'black',
            cursor: isDisabled ? 'not-allowed' : 'pointer',

            ':active': {
                ...styles[':active'],
                backgroundColor: !isDisabled
                    ? isSelected
                        ? 'rgba(84,133,228,.075)'
                        : 'rgba(84,133,228,.075)'
                    : undefined,
            },
        };
    },
    input: (styles) => ({ ...styles, ...dot() }),
    placeholder: (styles) => ({ ...styles, ...dot('#ccc') }),
    singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),
};

const Select2WColor = ({ options, defaultValue = null, value = null, isSearchable = false, isClearable = false, onChange, isMulti = false }) => {
    let defaultOptions;

    if (typeof defaultValue == Array) {
        defaultOptions = options.filter(option => defaultValue.includes(option.value));
    } else {
        defaultOptions = options.filter(option => option.value == defaultValue);
    }
    
    return (
        <Select
            placeholder="Seçiniz..."
            options={options}
            styles={colourStyles}
            isSearchable={isSearchable}
            isClearable={isClearable}
            onChange={onChange}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            classNamePrefix="cts-select2"
            isMulti={isMulti}
            {...(defaultValue ? { defaultValue: defaultOptions } : { value: value })}
        />
    )
}

const Select2 = ({ options, defaultValue, isSearchable = false, isClearable = false, isMulti = false, onChange }) => {
    const defaultOption = options.find(option => option.value === defaultValue);

    return (
        <Select
            placeholder="Seçiniz..."
            defaultValue={defaultOption}
            options={options}
            isSearchable={isSearchable}
            isClearable={isClearable}
            isMulti={isMulti}
            onChange={onChange}
            menuPortalTarget={document.body}
            menuPosition="fixed"
        />
    )
}

export { Select2, Select2WColor };